import React from "react";
import { Breadcrumb, Card, Collapse, Divider, Table, Modal, Spin } from "antd";
import { InputNumber, Radio, Rate, Slider, Switch, message, Upload } from "antd";
import { AutoComplete, Button, Cascader, Checkbox, Col, Form, Icon, Input, Row, Select, Tooltip, formLayout } from "antd";
import IntlMessages from "util/IntlMessages";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { OptionService } from "../../../services";
import { MenuService } from "../../../services";
import { resolveOptionId } from "../optionUtils";
import "../../../../src/routes/components/dataDisplay/Collapse/basic.less";
import "../../../../src/routes/components/dataEntry/Form/otherFormControls.less";
// ---------------drag sorting
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import DraggableBodyRow from "../../menuList/menuInfo/DraggableBodyRow";
// ---------------drag sorting

// <------------------------------------------
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import MenuOutline from "@ant-design/icons/MenuOutlined";
import arrayMove from "array-move";
// Switch script start
function onChange(checked) {
  console.log(`switch to ${checked}`);
}
// Switch script start

// search-script
const Search = Input.Search;
// search-script-end

const FormItem = Form.Item;
const Option = Select.Option;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

// import "./basic.less";

const Panel = Collapse.Panel;


// const text = `
//   A dog is a type of domesticated animal.
//   Known for its loyalty and faithfulness,
//   it can be found as a welcome guest in many households across the world.
// `;
const callback = (key) => {
  console.log(key);
};

// const Basic = () => {

// };

const columns = [
  {
    title: <IntlMessages id="menuList.sort" />,
    dataIndex: "sort",
    width: 30,
    className: "drag-visible",
    render: () => <DragHandle />,
  },
  {
    title: 'Option Name',
    dataIndex: 'optionName',
    key: 'optionName',
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
  }
];

const data = [
  {
    key: '1',
    optionName: 'Toppings',
    type: 'Single Selection',
  },
  {
    key: '2',
    optionName: 'Drinks',
    type: 'Multi Selection',
  },
  {
    key: '3',
    optionName: 'Bread',
    type: 'Single Selection',
  },
  {
    key: '4',
    optionName: 'Size',
    type: 'Single Selection (Primary)',
  }

];

// AddOption-tabile
const columnsAddOption = [
  {
    title: 'Items',
    dataIndex: 'items',
    key: 'items',
  },
  {
    title: 'Price(Excl Of Tax)',
    dataIndex: 'priceExcl',
    key: 'priceExcl',
  }
];

const dataAddOption = [
  {
    key: '1',
    items: 'Olives',
    priceExcl: '5',
  },
  {
    key: '2',
    items: 'Onion',
    priceExcl: '5',
  },
  {
    key: '3',
    items: 'Tomamtos',
    priceExcl: '5',
  }

];
// AddOption-tabile-end

// AddMultiOption-tabile
const columnsAddMultiOption = [
  {
    title: <IntlMessages id="option.items" />,
    dataIndex: 'items',
    key: 'items',
  },
  {
    title: <IntlMessages id="option.min" />,
    dataIndex: 'min',
    key: 'min',
  },
  {
    title: <IntlMessages id="option.max" />,
    dataIndex: 'max',
    key: 'max',
  },
  {
    title: <IntlMessages id="option.priceExclOfTax" />,
    dataIndex: 'priceExcl',
    key: 'priceExcl',
  },
  {
    title: <IntlMessages id="option.action" />,
    dataIndex: 'action',
    key: 'action',
  }
];

const dataAddMultiOption = [
  {
    key: '1',
    items: 'Coke',
    min: '5',
    max: '5',
    priceExcl: '10',
  },
  {
    key: '2',
    items: 'Sprinte',
    min: '5',
    max: '10',
    priceExcl: '10',
  },
  {
    key: '3',
    items: 'Fanta',
    min: '5',
    max: '10',
    priceExcl: '10',
  }

];
// AddMultiOption-tabile-end


// handleSubmit = (e) => {
//   e.preventDefault();
//   this.props.form.validateFields((err, values) => {
//     if (!err) {
//       console.log('Received values of form: ', values);
//     }
//   });
// };

// <-----------------------
const SortableItem = sortableElement((props) => <tr {...props} />);
const SortableContainer = sortableContainer((props) => <tbody {...props} />);
const DragableBodyRow = ({ index, className, style, ...restProps }) => (
  <SortableItem index={restProps["data-row-key"]} {...restProps} />
);
//-------------------------->
const DragHandle = sortableHandle(() => (
  <MenuOutline style={{ cursor: "pointer", color: "#999" }} />
));
//   upload-script start
const props = {
  name: 'file',
  action: '//jsonplaceholder.typicode.com/posts/',
  headers: {
    authorization: 'authorization-text',
  },
  onChange(info) {
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};
//   upload-script end

class optionAddMulti extends React.Component {
  // form-scripts start
  handleFormLayoutChange = (e) => {
    this.setState({ formLayout: e.target.value });
  }

  constructor() {
    super();
    this.state = {
      optionId: "",
      optionItemId: "",
      itemList: [],

      isAddButton: true,
      spin: false,
      spinForItem: false,

      formLayout: 'horizontal',
      visible: false,
      addItem: false,
      addOption: false
    };
  }

 // ---------drag sorting
 components = {
  body: {
    row: DraggableBodyRow,
  },
};

onRow = (record, index) => ({
  index,
  moveRow: this.moveRow,
});

moveRow = (dragIndex, hoverIndex) => {
  const dataSource = this.state.itemList;
  console.log("before", this.state.itemList);

  if (dragIndex !== hoverIndex) {
    const newData = arrayMove(
      [].concat(dataSource),
      dragIndex,
      hoverIndex
    ).filter((el) => !!el);

    // let newArray = [...this.state.itemList];
    // newArray[this.state.currentTable] = {
    //   ...newArray[this.state.currentTable],
    //   itemList: newData,
    // };

    this.setState({
      itemList: newData,
    });

    console.log("after", this.state.itemList);
  }
};
// --------------drag sorting

  componentDidMount() {
    const optionInfo = this.props.location.info || {};
    this.props.form.setFieldsValue({
      name: optionInfo.name || "",
      isAvailableForOption: optionInfo.isAvailable,
      maxSelectable: optionInfo.maxSelectable || ""
    });

    this.syncOptionState(optionInfo);
  }

  componentDidUpdate(prevProps) {
    const prevOptionId = prevProps.location && prevProps.location.info && prevProps.location.info.optionId;
    const currentOptionId = this.props.location && this.props.location.info && this.props.location.info.optionId;
    const prevOptionItems = prevProps.location && prevProps.location.info && prevProps.location.info.optionItems;
    const currentOptionItems = this.props.location && this.props.location.info && this.props.location.info.optionItems;
    const prevKey = prevProps.location && prevProps.location.key;
    const currentKey = this.props.location && this.props.location.key;

    if (prevKey !== currentKey || prevOptionId !== currentOptionId || prevOptionItems !== currentOptionItems) {
      const optionInfo = this.props.location.info || {};
      this.props.form.setFieldsValue({
        name: optionInfo.name || "",
        isAvailableForOption: optionInfo.isAvailable,
        maxSelectable: optionInfo.maxSelectable || ""
      });
      this.syncOptionState(optionInfo);
    }
  }

  syncOptionState = (optionInfo = {}) => {
    const optionItemList = optionInfo.optionItems || [];
    const items = optionItemList.map((optionItem, index) => ({
      key: index,
      id: optionItem.Id,
      items: optionItem.Name,
      min: optionItem.MinCount,
      max: optionItem.MaxCount,
      priceExcl: optionItem.Price,
      action: (
        <span>
          <a onClick={() => this.openMenuInfo(optionItem.Id, optionItem.Name, optionItem.MinCount, optionItem.MaxCount, optionItem.Price, optionItem.IsAvailable, optionItem.IsSelectedByDefault)}>
            <i className="fa fa-pencil"></i>
          </a>
          <a style={{ marginLeft: 10 }} onClick={() => this.deleteOptionItem(optionItem.Id)}>
            <i className="fa fa-trash"></i>
          </a>
        </span>
      ),
    }));

    this.setState({
      optionId: optionInfo.optionId || "",
      itemList: items,
      isAddButton: optionInfo.optionId ? false : true,
      optionItemId: "",
    });
  };

  saveSortedList = async () => {
    const optionWithOptionItem = this.state.itemList;
    
    // Map each item to get OptionItemId and SortOrder
    const sortedList = optionWithOptionItem.map((item, index) => ({
      OptionItemId: item.id,
      SortOrder: index
    }));
    
    // Create the final sorted data structure
    const sortedData = {
      SubOptionItems: [{
        OptionId: this.state.optionId,
        SubOptionItemSortOrderList: sortedList,
      }]
    };
  
    const response = await MenuService.updateOptionItemSorting(sortedData);
    console.log(response);
  
    if (response && response.Success) {
      message.success("Sorted List Successfully Updated");
    } else {
      message.error(response.APIMessage);
    }
  };

  addOptions = async (event) => {
    event.preventDefault();

    this.props.form.validateFields(['name', 'maxSelectable', 'isAvailableForOption', 'isSelectedByDefault'], async (err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);

        const optionData = {
          OptionId: this.state.optionId || "",
          Name: values.name,
          MaxSelectable: values.maxSelectable,
          IsAvailable: values.isAvailableForOption,
          IsSelectedByDefault: values.isSelectedByDefault
        }

        this.setState({ spin: true })
        const response = await OptionService.addOptionsForMultiSelect(optionData);

        if (response && response.APICode == 8) {
          message.error('Option name already exists');
        } else if (response && response.Success) {
          if(this.state.optionId){
            message.success('Option Updated');
          }else{
            message.success('Option Added');
          }
          
          // this.props.form.resetFields();
          const optionList = Array.isArray(response.Data) ? response.Data : [];
          const nextOptionId = resolveOptionId(this.state.optionId, optionList, values.name);
          if (nextOptionId || this.state.optionId) {
            this.setState({
              optionId: nextOptionId || this.state.optionId
            });
          }
        }
        else if(response.APICode == 14){
          this.props.form.setFieldsValue({ isAvailableForOption: true });
          Modal.error({
            title: response.APIMessage,
            content: <span>Here is the associated list. <ul>{response.Data.map(v=><li>{v.Name}</li>)}</ul></span>,
          });
        }
        else if(response.APICode == 114){
          this.props.form.setFieldsValue({ isAvailableForOption: true });
          Modal.error({
            title: response.APIMessage,
            content: <span>Here is the associated menu item list. <ul>{response.Data.map(v=><li>{v.Name}</li>)}</ul></span>,
          });
        }
        else {
          message.error(response.APIMessage);
        }
        this.setState({ spin: false })
      }
    });
  }

  addOptionDetails = async (event) => {
    event.preventDefault();
    this.props.form.validateFields(['itemName', 'price', 'minQuantity', 'maxQuantity', 'isAvailableForOptionDetails', 'isSelectedByDefault'], async (err, values) => {
      if (!err) {
        console.log('Received values of form: ', values);

        const optionDetailsData = {
          OptionId: this.state.optionId,
          OptionItemId: this.state.optionItemId || "",
          Name: values.itemName,
          DefaultPrice: values.price,
          IsAvailable: values.isAvailableForOptionDetails,
          MinCount: values.minQuantity,
          MaxCount: values.maxQuantity,
          IsSelectedByDefault: values.isSelectedByDefault
        }

        this.setState({ spinForItem: true })
        const response = await OptionService.addOptionDetails(optionDetailsData);

        if (response && response.Success) {
          message.success('Item Added');
          this.setState({ spinForItem: false })
          this.props.form.resetFields(['itemName', 'price', 'minQuantity', 'maxQuantity', 'isAvailableForOptionDetails', 'isSelectedByDefault']);

          const optionList = Array.isArray(response.Data) ? response.Data : [];
          let optionItemList = [];
          const matchedOption = optionList.find((option) => option && option.Id === this.state.optionId)
            || optionList.find((option) => option && option.Id === resolveOptionId(this.state.optionId, optionList, this.props.form.getFieldValue('name')));

          if (matchedOption) {
            optionItemList = matchedOption.OptionItems || [];
          }

          let items = [];

          for (let i = 0; i < optionItemList.length; i++) {
            items.push({
              key: i,
              id: optionItemList[i].Id,
              items: optionItemList[i].Name,
              min: optionItemList[i].MinCount,
              max: optionItemList[i].MaxCount,
              priceExcl: optionItemList[i].Price,
              action: (
                <span>
                  <a onClick={() => this.openMenuInfo(optionItemList[i].Id, optionItemList[i].Name, optionItemList[i].MinCount, optionItemList[i].MaxCount, optionItemList[i].Price, optionItemList[i].IsAvailable, optionItemList[i].IsSelectedByDefault)}>
                    <i className="fa fa-pencil"></i>
                  </a>
                  <a style={{ marginLeft: 10 }} onClick={() => this.deleteOptionItem(optionItemList[i].Id)}>
                    <i className="fa fa-trash"></i>
                  </a>
                </span>
              ),
            })
          }

          this.setState({
            itemList: items,
            optionItemId: ""
          })

        }
        else {
          if (response.APIMessage == "Option not found") {
            message.error("Please add option first than option details..!");
          } else {
            message.error(response.APIMessage);
          }
        }
      }
    });
  }

  openMenuInfo = (itemId, itemName, itemMin, itemMax, itemPrice, isAvailable, isSelectedByDefault) => {
    this.props.form.setFieldsValue({
      itemName: itemName || "",
      minQuantity: itemMin,
      maxQuantity: itemMax,
      price: itemPrice || "",
      isAvailableForOptionDetails: isAvailable || "",
      isSelectedByDefault: isSelectedByDefault || false
    })

    this.setState({
      optionItemId: itemId
    })
  }

  deleteOptionItem = async (itemId) => {
    const _this = this;
    const optionItemInfo = {
      OptionItemId: itemId,
    };

    Modal.confirm({
      title: "Do you really want to delete this option item?",
      icon: <ExclamationCircleOutlined />,
      content: "This action cannot be undone.",
      onOk() {
        _this.deleteOptionItemApi(optionItemInfo, itemId);
      },
      onCancel() {
        // no-op
      },
    });
  };

  deleteOptionItemApi = async (optionItemInfo, itemId) => {
    this.setState({ spinForItem: true });
    const response = await OptionService.deleteOptionItem(optionItemInfo);

    if (response && response.Success) {
      message.success("Item Deleted!");
      const filteredItems = this.state.itemList.filter((item) => item.id !== itemId);
      this.setState({
        itemList: filteredItems,
        spinForItem: false,
      });
      if (this.state.optionItemId === itemId) {
        this.props.form.resetFields(['itemName', 'price', 'minQuantity', 'maxQuantity', 'isAvailableForOptionDetails', 'isSelectedByDefault']);
        this.setState({ optionItemId: "" });
      }
    } else if (response && response.APICode == 14) {
      Modal.error({
        title: response.APIMessage,
        content: (
          <span>
            Here is the associated list. <ul>{response.Data.map((v) => <li>{v.Name}</li>)}</ul>
          </span>
        ),
      });
      this.setState({ spinForItem: false });
    } else {
      message.error(response && response.APIMessage ? response.APIMessage : "Delete failed.");
      this.setState({ spinForItem: false });
    }
  };

  // form-scripts end
  // Modal-scripts start
  showModal = () => {
    this.setState({
      visible: true,
    });
  };
  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  addItem = (e) => {
    this.setState({
      addItem: !this.state.addItem,
    });
  };
  addOption = (e) => {
    this.setState({
      addOption: !this.state.addOption,
    });
  };
  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  // Modal-scripts end
  render() {
    //   const {getFieldDecorator} = this.props.form;
    // const formItemLayout = {
    //   labelCol: {xs: 24, sm: 6},
    //   wrapperCol: {xs: 24, sm: 14},
    // };
    // form-scripts start
    const { formLayout } = this.state;
    const formItemLayout = formLayout === 'horizontal' ? {
      labelCol: { xs: 24, sm: 6 },
      wrapperCol: { xs: 24, sm: 16 },
    } : null;
    const buttonItemLayout = formLayout === 'horizontal' ? {
      wrapperCol: { xs: 24, sm: { span: 14, offset: 6 } },
    } : null;
    // form-scripts end

    // MULTIPLE-scripts start
    const children = [];
    for (let i = 1; i < 10; i++) {
      children.push(<Option key={i.toString(36) + i}>{'test'}</Option>);
    }
    function handleChange(value) {
      console.log(`selected ${value}`);
    }
    // MULTIPLE-scripts End

    const { getFieldDecorator } = this.props.form;

    return (

      <div className="menu-editor-box card-pad-new menu-cate-list option-list Add-op-multi">
        <div className="ant-row margin-btm-20 d-none">
          <div className="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24">
            <div className="Breadcrumb-inner-box menu-ed">
              <Breadcrumb>
                <Breadcrumb.Item>Menu</Breadcrumb.Item>
                <Breadcrumb.Item>Thai House Wok - Folkungagatan</Breadcrumb.Item>
                <Breadcrumb.Item><span className="gx-link">View on Delivery Pizza.com</span></Breadcrumb.Item>
              </Breadcrumb>
              <div className="icon-more"><i class="icon icon-ellipse-h"></i></div>
            </div>
          </div>
        </div>

        <div className="payout-report-box option-add-multi-box">
          <Card className="gx-card breadcrumb-box" title="">
            <div>
              <div className="title-sub"><h2><IntlMessages id="option.options" /></h2>
                <hr className="hr-line"></hr>
              </div>

              <div class="ant-row Platform-Charges">
                <Form onSubmit={(e) => this.addOptions(e)} layout={formLayout}>
                  <div class="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 platform-charges-lft">
                    <div className="detail-res-lft">
                      <div class="ant-row charge-form">
                        <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                          <label><IntlMessages id="option.type" /> :</label>
                        </div>
                        <div class="ant-col ant-col-xs-24 ant-col-sm-8 gx-mb-3">
                          <Select disabled={this.props.location.info} className="" defaultValue="Select-2" onChange={handleChange}>
                            <Option value="Select-1" onClick={() => { this.props.history.push("optionAddSingal") }}><IntlMessages id="option.singleSelectionOption" /></Option>
                            <Option value="Select-2" onClick={() => { this.props.history.push("optionAddMulty") }}><IntlMessages id="option.multiSelectionOption" /></Option>
                          </Select>
                        </div>
                        <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 gx-ml-3 charge-lable">
                          <label><IntlMessages id="option.disableEnable" /> :</label>
                        </div>
                        <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3">
                          <FormItem
                            // label={<IntlMessages id="option.disableEnable" />}
                            {...formItemLayout}
                          >
                            {getFieldDecorator('isAvailableForOption', {
                              valuePropName: 'checked',
                              initialValue: true,
                            })(
                              <Switch />
                            )}
                          </FormItem>
                        </div>
                      </div>
                      <div class="ant-row charge-form">
                        <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                          <label><IntlMessages id="option.name" /> :</label>
                        </div>
                        <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 gx-ml-3">
                          <FormItem
                          // label={<IntlMessages id="option.name" />}
                          // {...formItemLayout}
                          >
                            {getFieldDecorator('name', {
                              rules: [{
                                required: true, message: 'Required!',
                              }],
                            })(
                              <Input placeholder="Drinks" />
                            )}
                          </FormItem>
                        </div>
                        {/*<div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                      <Checkbox>Primary</Checkbox>
                      </div>*/}
                        <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                          <label><IntlMessages id="option.maxSelectable" /> :</label>
                        </div>
                        <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3">
                          <FormItem
                            // label={<IntlMessages id="option.maxSelectable" />}
                            {...formItemLayout}
                          >
                            {getFieldDecorator('maxSelectable', {
                              rules: [{
                                required: true, type: 'number', min: 0, message: 'Should be positive number!',
                              }],
                            })(
                              <InputNumber placeholder="0" />
                            )}
                          </FormItem>
                        </div>
                        <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 add-btn-rite">
                          {
                            this.state.spin ? <Spin /> :
                              <Button htmlType="submit" type="primary" class="ant-btn color-white ant-btn-primary">
                                <i class="icon icon-add"></i>
                                {this.state.isAddButton ? <IntlMessages id="option.addOption" /> : <IntlMessages id="option.updateOption" />}
                              </Button>
                          }
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </Form>
              </div>

              <div className="title-sub"><h2><IntlMessages id="option.addOptionDetails" /></h2>
                <hr className="hr-line"></hr>
              </div>
              <div class="ant-row Platform-Charges">
                <Form onSubmit={(e) => this.addOptionDetails(e)} layout={formLayout}>
                  <div class="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 platform-charges-lft">
                    <div className="detail-res-lft">

                      <div class="ant-row charge-form">
                        <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                          <label><IntlMessages id="option.itemName" /> :</label>
                        </div>
                        <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3">
                          <FormItem
                          // label={<IntlMessages id="option.itemName" />}
                          // {...formItemLayout}
                          >
                            {getFieldDecorator('itemName', {
                              rules: [{
                                required: true, message: 'Required!',
                              }],
                            })(
                              <Input disabled={this.state.optionId ? false : true} placeholder="Fanta" />
                            )}
                          </FormItem>
                        </div>
                        <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                          <label><IntlMessages id="option.minQuantity" /> :</label>
                        </div>
                        <div class="ant-col ant-col-xs-24 ant-col-sm-2 gx-mb-3">
                          <FormItem
                          // label={<IntlMessages id="option.maxSelectable" />}
                          // {...formItemLayout}
                          >
                            {getFieldDecorator('minQuantity', {
                              rules: [{
                                required: true, type: 'number', min: 1, message: 'Should be min one!',
                              }],
                            })(
                              <InputNumber disabled={this.state.optionId ? false : true} placeholder="0" />
                            )}
                          </FormItem>
                        </div>
                        <div className="ant-col ant-col-xs-24 ant-col-sm-3 gx-mb-3">
<FormItem>
    {this.props.form.getFieldDecorator('isSelectedByDefault', {
      valuePropName: 'checked',
      //initialValue: !!this.state.isSelectedByDefault,
    })(
      <Checkbox>
        By default selection
      </Checkbox>
    )}
  </FormItem>
</div>
<div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 gx-ml-3 charge-lable">
                          <label><IntlMessages id="option.disableEnable" /> :</label>
                        </div>
<div class="ant-col ant-col-xs-24 ant-col-sm-2 gx-mb-3">
                          <FormItem
                          // label={<IntlMessages id="option.disableEnable" />}
                          // {...formItemLayout}
                          >
                            {getFieldDecorator('isAvailableForOptionDetails', {
                              valuePropName: 'checked',
                              initialValue: true,
                            })(
                              <Switch disabled={this.state.optionId ? false : true} />
                            )}
                          </FormItem>
                        </div>
                      </div>
                      <div class="ant-row charge-form">
                        <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                          <label><IntlMessages id="option.price" /> :</label>
                        </div>
                        <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3">
                          <FormItem
                          // label={<IntlMessages id="option.price" />}
                          // {...formItemLayout}
                          >
                            {getFieldDecorator('price', {
                              rules: [{
                                required: true, type: 'number', min: 0, message: 'Should be positive number!',
                              }],
                            })(
                              <InputNumber disabled={this.state.optionId ? false : true} placeholder="5" />
                            )}
                          </FormItem>
                        </div>
                        <div class="ant-col ant-col-xs-24 ant-col-sm-4 gx-mb-3 charge-lable">
                          <label><IntlMessages id="option.maxQuantity" /> :</label>
                        </div>
                        <div class="ant-col ant-col-xs-24 ant-col-sm-3 gx-mb-3">
                          <FormItem
                          // label={<IntlMessages id="option.maxSelectable" />}
                          // {...formItemLayout}
                          >
                            {getFieldDecorator('maxQuantity', {
                              rules: [{
                                required: true, type: 'number', min: 1, message: 'Should be min one!',
                              }],
                            })(
                              <InputNumber disabled={this.state.optionId ? false : true} placeholder="0" />
                            )}
                          </FormItem>
                        </div>
                        
                        <div class="ant-col ant-col-xs-24 ant-col-sm-3 gx-mb-3 add-btn-rite">
                          {
                            this.state.spinForItem ? <Spin /> :
                              <Button disabled={this.state.optionId ? false : true} htmlType="submit" type="primary" class="ant-btn color-white ant-btn-primary">
                                <i class="icon icon-add"></i>
                                {this.state.optionItemId ? <IntlMessages id="option.update" /> : <IntlMessages id="option.add" />}
                              </Button>
                          }
                          {/* <button type="button" class="ant-btn color-white ant-btn-primary"><i class="icon icon-add"></i><span> Add</span></button> */}
                        </div>
                        <div class="ant-col ant-col-xs-23 ant-col-sm-2 gx-mb-1 add-btn-rite">
                        {
                            <Button
                            type="primary"
                            className="color-white"
                            onClick={(e) => this.saveSortedList()}
                          >
                            <i className="fa fa-floppy-o"></i>
                            <IntlMessages id="menuList.saveSortedList" />
                          </Button>
                          }
                          </div>
                      </div>

                    </div>
                  </div>
                </Form>
              </div>
              <div className="title-sub"><h2><IntlMessages id="option.optionDetails" /></h2>
                <hr className="hr-line"></hr>
              </div>
              <Table className="gx-table-responsive user-manage-tabile" columns={columnsAddMultiOption} dataSource={this.state.itemList}
              rowKey="key"
              components={this.components}
              onRow={this.onRow}
              pagination={false}
              />
              <div class="ant-row Platform-Charges delivery-charges">
                <div class="ant-col ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 platform-charges-lft">
                  <div className="detail-res-lft">

                  </div>
                </div>

              </div>
            </div>
          </Card>

        </div>


        <Modal
          title="Add Category"
          visible={this.state.addItem}
          onOk={this.addItem}
          onCancel={this.addItem}
        >
          <div className="item-detail-edit-box">
            {/* <p>Some contents...</p> */}
            <Form layout={formLayout}>

              <FormItem
                label="Category Name"
                {...formItemLayout}
              >
                <Input placeholder="" />
              </FormItem>
              {/* <FormItem
                                label="Price"
                                {...formItemLayout}
                            >
                                <Input placeholder=""/>
                           </FormItem>*/}
              <FormItem
                label="Image"
                {...formItemLayout}
              >
                <Upload {...props}>
                  <Button className="btn-upload-cust">
                    <Icon type="upload" /> Upload
                                </Button>
                </Upload>
                {/* <Input placeholder=""/> */}
              </FormItem>
            </Form>

          </div>

        </Modal>{/* modal-edit-end */}

        {/* modal-edit */}
        <Modal
          title="Add Category"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <div className="item-detail-edit-box">
            {/* <p>Some contents...</p> */}
            <Form layout={formLayout}>
              <FormItem
                label="Category name"
                {...formItemLayout}
              >
                <Input placeholder="" />
              </FormItem>

            </Form>

          </div>

        </Modal>
        {/* modal-add-option */}

        <Modal
          title="Add a new option"
          visible={this.state.addOption}
          onOk={this.addOption}
          onCancel={this.addOption}
        >
          <div className="item-detail-edit-box">
            <p>Option Details</p>
            <Form layout={formLayout}>
              <FormItem
                label="Optin type"
                {...formItemLayout}
              >
                {/* <Input placeholder=""/> */}
              </FormItem>
              <FormItem
                label="Name"
                {...formItemLayout}
              >
                <Input placeholder="" />
              </FormItem>

            </Form>

          </div>

        </Modal>


      </div>
    );
  }
}

//const WrappedOptionAddMulti = Form.create()(optionAddMulti)
const WrappedOptionAddMulti = DragDropContext(HTML5Backend)(
  Form.create()(optionAddMulti)
);
export default WrappedOptionAddMulti;